import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Input, Label, Row } from 'reactstrap';
import OSelect from '../../../../Components/OElements/OSelect';
import PageComponents from './Graph/PageComponents';
import { useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { getGraphList } from '../../../../slices/thunks';


const TitleGraphTextPage = ({ elements, page, handleDynamicChange, validation, edit }) => {

    const text = elements.length > 0 ? elements[0].text : '';
    const graph = elements.length > 0 ? elements[0].graph : '';

    const dispatch = useDispatch();

    const selectorReport = createSelector(
        state => state.Screen,
        report => ({
            data: report.graphList
        })
    );

    const { data } = useSelector(selectorReport);

    const [graphNoEdit, setGraphNoEdit] = useState(null);
    const [selectedGraph, setSelectedGraph] = useState(graph);
    const [selectedGraphCode, setSelectedGraphCode] = useState(null);
    const [typesList, setTypesList] = useState([]);

    const handleGraphSelect = (optionSelected) => {
        setSelectedGraph(optionSelected);
        setSelectedGraphCode(optionSelected?.code);
        handleDynamicChange(0, 'graph', optionSelected?._id);
    };

    useEffect(() => {
        dispatch(getGraphList());
    }, []);


    useEffect(() => {
        if (data && data.length > 0) {
            const list = data.map(type => ({
                value: type._id,
                label: type.name,
                item: type
            }));
            setTypesList(list);
        }
    }, [data]);

    useEffect(() => {
        if (graph) {
            const foundType = data.find(type => type._id === graph);
            setGraphNoEdit(foundType);
        }
    }, [graph, data]);

    const SelectedGraphComponent = edit
        ? PageComponents[selectedGraphCode]
        : PageComponents[graphNoEdit?.code];

    return (
        <Card className='border card-border-primary'>
            <Row className="g-0">
                <Col md={9}>
                    <CardBody>
                        {edit && typesList.length > 0 ? (
                            <Col md={6}>
                                <OSelect
                                    label='Gráfico'
                                    id='graph'
                                    name='graph'
                                    value={graph}
                                    onSelect={handleGraphSelect}
                                    // requestApi={() => getGraphList({})}                        
                                    itemsSelect={typesList}
                                    validation={validation}
                                />
                            </Col>
                        ) : null}
                        <Col md={12}>
                            {SelectedGraphComponent && (
                                <div style={{ height: '300px' }}>
                                    <React.Suspense fallback={<div>Cargando...</div>}>
                                        <SelectedGraphComponent />
                                    </React.Suspense>
                                </div>
                            )}
                        </Col>
                    </CardBody>
                </Col>
                <Col md={3} className="bg-primary text-white">
                    <Row className="g-0">
                        <Col md={12} className='p-2'>
                            <Label for="text" className="form-label">
                                Texto
                            </Label>
                            <Input
                                name="text"
                                id="text"
                                className="form-control"
                                placeholder="Ingrese un texto"
                                type="textarea"
                                value={text}
                                rows={10}
                                onChange={(e) => handleDynamicChange(0, 'text', e.target.value, page)}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Card>
    );
};

export default TitleGraphTextPage;
